import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { UiIconsList, UiIconsModule } from 'ui-icons';

import { UiPlatformButtonType } from '../button/button.model';

export interface ButtonGroup {
  disabled?: boolean;
  icon: UiIconsList;
  tooltip?: string;
  type?: UiPlatformButtonType;
  label?: string;
  callback?: () => void;
}

@Component({
  selector: 'ui-platform-button-group',
  templateUrl: './button-group.component.html',
  styleUrl: './button-group.component.less',
  imports: [
    NzButtonModule,
    UiIconsModule,
    RouterModule,
    NzToolTipModule
  ]
})
export class UiPlatformButtonGroupComponent {
  @Input() type: UiPlatformButtonType = 'primary';
  @Input() buttons: ButtonGroup[] = [];

  get nzType() {
    if (this.type === 'secondary') {
      return 'default';
    }

    if ([
        'text',
        'text-primary'
      ].includes(this.type)) {
      return 'text';
    }

    if ([
        'link',
        'link-primary',
        'link-secondary'
      ].includes(this.type)) {
      return 'link';
    }

    return 'primary';
  }
}
